export default __webpack_public_path__ + "static/media/marioVideo1.35c57980.mov";